<template>

</template>

<script>
import axios from 'axios';

export default {
  name: 'VerifyEmail',
  data: () => ({

    verifyemailsuccessalert: false,
  }),
  //
  created() {
    const verificationkey = this.$route.params.key;
    axios.post('rest-auth/registration/verify-email/', {
      key: verificationkey,
    })
      .then(() => {
        this.$parent.$emit('alert-emitted', {
          alert_icon: 'mdi-check-circle',
          alert_color: 'success',
          alert_message: 'Email confirmed! Welcome to Foraje! You can go ahead and sign in now',
          alert_model: true,
        });
      })
      .then(this.$router.push('/sign_in'))
      .catch((e) => {
        this.errors.push(e);
      });
    return {
    };
  },


};
</script>

<style scoped>

</style>
